import type { App } from 'vue';
import { registerPartial } from '@precon-tools-suite-by-shared/vue-partials';
import dataAccessPlugin, {
    type GinoImportsOptions,
} from '@precon-tools-suite-by-shared/gino-user-imports-data-access';
export { default as routes } from './routes';

export default {
    install(app: App, options: GinoImportsOptions = {}) {
        app.use(dataAccessPlugin, options);

        registerPartial(
            app,
            '@precon-tools-suite-by-shared/gino-user-imports-feature/partials/StartImport',
            () => import('./partials/StartImport.vue')
        );
    },
};
